import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) return setError(error.message);
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="bg-gray-800 shadow-xl rounded-xl p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-white flex items-center justify-center gap-2">
          <img src="/images/logo_h.png" alt="Hotify" className="w-10 h-10" />
          <span className="text-white">Hotify</span>
          </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="w-full p-3 border border-gray-300 rounded-lg bg-gray-700 text-white"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{outline: 'none'}}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            className="w-full p-3 border border-gray-300 rounded-lg bg-gray-700 text-white"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{outline: 'none'}}
            required
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <button
            type="submit"
            className="w-full bg-orange-500 text-white py-3 rounded-lg hover:bg-orange-600 transition"
          >
            Entrar
          </button>
        </form>
        <p className="mt-4 text-center text-sm text-gray-400">
          Ainda não tem conta?{' '}
          <a href="/" className="text-orange-500 hover:underline">
            Assine um plano
          </a>
        </p>
      </div>
    </div>
  );
}

